import {
  FormControl,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from "@mui/material";
const subCategories = {
  "Welding Machine": [
    { value: "Mig Welding Machine", label: "Mig Welding Machine" },
    { value: "Arc Welding Machine", label: "Arc Welding Machine" },
    { value: "Tig Welding Machine", label: "Tig Welding Machine" },
    { value: "Combi Welding Machine", label: "Combi Welding Machine" },
  ],
  "Acrylic Laser Cutting Machine": [
    {
      value: "Single Spindle",
      label: "Single Spindle",
    },
    {
      value: "Double Spindle",
      label: "Double Spindle",
    },
  ],
  "CNC Router Machine": [
    {
      value: "Single Spindle",
      label: "Single Spindle",
    },
    {
      value: "Double Spindle",
      label: "Double Spindle",
    },
  ],
  "Paint Compressor Machine": [
    {
      value: "Portable (2HP)",
      label: "Portable (2HP)",
    },
    {
      value: "Fixed (3HP & Above)",
      label: "Fixed (3HP & Above)",
    },
  ],
  "Channel Letter Bending Machine": [
    {
      value: "Stainless Steel(SS)",
      label: "Stainless Steel(SS)",
    },
    {
      value: "Aluminum",
      label: "Aluminum",
    },
    {
      value: "Hybrid",
      label: "Hybrid",
    },
  ],
};

const FabricationMachinesDetails = ({
  machine,
  handleInputChangeMachineDetails,
  activeProduct,
  formData,
  operation,

  index,
  categoryLabels,
  handleInputChange,
}) => {
  console.log("forndnd", formData);
  return (
    <>
      {" "}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 p-4">
        {Object.keys(machine.details)?.map((field, fieldIndex) => (
          <div key={fieldIndex}>
            {machine.type === "Welding Machine" ? (
              <FormControl
                fullWidth
                size="small"
                sx={{
                  marginBottom: "7px",
                }}
              >
                <label
                  style={{
                    fontWeight: "400",
                    marginBottom: "0.5rem",
                  }}
                >
                  {categoryLabels[field]}
                </label>
                {field === "subCategory" ? (
                  <Select
                    size="small"
                    disabled={operation == "view"}
                    name={`machineDetails-${activeProduct}-${machine.type}-${field}`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.[field] || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct, // productType
                        "machinesNeededForFabrication", // machineCategory
                        machine.type, // machineType
                        field, // field name inside details
                        e.target.value // new value
                      );
                    }}
                    displayEmpty
                    renderValue={(selected) =>
                      !selected ? (
                        <span className="text-[var(--listdown-color)]">
                          Select Type of Welding Machine
                        </span>
                      ) : (
                        selected
                      )
                    }
                    inputProps={{
                      "aria-label": `Select ${field}`,
                    }}
                  >
                    {subCategories["Welding Machine"]?.map(
                      (weldingMachine, i) => (
                        <MenuItem value={weldingMachine.value} key={i}>
                          <Radio
                            checked={
                              formData?.products
                                ?.find((p) => p.productType === activeProduct)
                                ?.machinesNeededForFabrication?.find(
                                  (m) => m.type === machine.type
                                )?.details?.[field] === weldingMachine.value
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleInputChangeMachineDetails(
                                  activeProduct,
                                  "machinesNeededForFabrication",
                                  machine.type,
                                  field,
                                  weldingMachine.value
                                );
                              }
                            }}
                            style={{
                              paddingRight: "8px",
                            }}
                          />
                          {weldingMachine.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                ) : field === "ampereOfMachine" ? (
                  <TextField
                    fullWidth
                    disabled={operation == "view"}
                    size="small"
                    select
                    name={`machineDetails-${activeProduct}-${machine.type}-ampereOfMachine`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.ampereOfMachine || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "ampereOfMachine",
                        e.target.value
                      );
                    }}
                    required
                  >
                    <MenuItem value={200}>200 A</MenuItem>
                    <MenuItem value={300}>300 A</MenuItem>
                    <MenuItem value={400}>400 A</MenuItem>
                  </TextField>
                ) : (
                  <TextField
                    fullWidth
                    size="small"
                    disabled={operation == "view"}
                    select
                    name={`machineDetails-${activeProduct}-${machine.type}-ageOfMachine`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.ageOfMachine || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "ageOfMachine",
                        e.target.value
                      );
                    }}
                    required
                  >
                    <MenuItem value="0-4">0 to 4 years</MenuItem>
                    <MenuItem value="4+">4 years and above</MenuItem>
                  </TextField>
                )}
              </FormControl>
            ) : machine.type === "Paint Compressor Machine" ? (
              <FormControl
                fullWidth
                size="small"
                sx={{
                  marginBottom: "7px",
                }}
              >
                <label
                  style={{
                    fontWeight: "400",
                    marginBottom: "0.5rem",
                  }}
                >
                  {categoryLabels[field]}
                </label>
                {field === "subCategory" ? (
                  <Select
                    disabled={operation == "view"}
                    name={`machineDetails-${activeProduct}-${machine.type}-${field}`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.[field] || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        field,
                        e.target.value
                      );
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span className="text-[var(--listdown-color)]">
                            Select Type of Machine
                          </span>
                        );
                      }
                      return selected;
                    }}
                    inputProps={{
                      "aria-label": `Select ${field}`,
                    }}
                  >
                    {subCategories["Paint Compressor Machine"]?.map(
                      (paintMachine, i) => (
                        <MenuItem value={paintMachine.value} key={i}>
                          <Radio
                            checked={
                              formData?.products
                                ?.find((p) => p.productType === activeProduct)
                                ?.machinesNeededForFabrication?.find(
                                  (m) => m.type === machine.type
                                )?.details?.[field] === paintMachine.value
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleInputChangeMachineDetails(
                                  activeProduct,
                                  "machinesNeededForFabrication",
                                  machine.type,
                                  field,
                                  paintMachine.value
                                );
                              }
                            }}
                            style={{
                              paddingRight: "8px",
                            }}
                          />
                          {paintMachine.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                ) : (
                  <TextField
                    fullWidth
                    disabled={operation == "view"}
                    select // Enables dropdown
                    size="small"
                    name={`machineDetails-${activeProduct}-${machine.type}-ageOfMachine`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.ageOfMachine || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "ageOfMachine",
                        e.target.value
                      );
                    }}
                    required
                  >
                    <MenuItem value="0-4">0 to 4 years</MenuItem>
                    <MenuItem value="4+">4 years and above</MenuItem>
                  </TextField>
                )}
              </FormControl>
            ) : machine.type === "CNC Router Machine" ? (
              <FormControl
                fullWidth
                size="small"
                sx={{
                  marginBottom: "7px",
                }}
              >
                <label
                  style={{
                    fontWeight: "400",
                    marginBottom: "0.5rem",
                  }}
                >
                  {categoryLabels[field]}
                </label>
                {field === "subCategory" ? (
                  <Select
                    disabled={operation == "view"}
                    name={`machineDetails-${activeProduct}-${machine.type}-subCategory`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.subCategory || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "subCategory",
                        e.target.value
                      );
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span className="text-[var(--listdown-color)]">
                            Select Type of Machine
                          </span>
                        );
                      }
                      return selected;
                    }}
                    inputProps={{
                      "aria-label": `Select ${field}`,
                    }}
                  >
                    {subCategories["CNC Router Machine"]?.map(
                      (subCategoryOfMachine, i) => {
                        return (
                          <MenuItem value={subCategoryOfMachine.value} key={i}>
                            <Radio
                              checked={
                                formData?.products
                                  ?.find(
                                    (ele) => ele.productType == activeProduct
                                  )
                                  ?.machinesNeededForFabrication?.find(
                                    (m) => m.type === machine.type
                                  )?.details[field] ==
                                subCategoryOfMachine.value
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  handleInputChange(
                                    {
                                      target: {
                                        name: `machinesNeededForFabrication-details-${machine.type}-${field}-${index}`,
                                        value: subCategoryOfMachine.value,
                                      },
                                    },
                                    index
                                  );
                                }
                              }}
                              style={{
                                paddingRight: "8px",
                              }}
                            />
                            {subCategoryOfMachine.value}
                          </MenuItem>
                        );
                      }
                    )}
                  </Select>
                ) : field === "powerOfMachine" ? (
                  <TextField
                    fullWidth
                    disabled={operation == "view"}
                    select // Enables dropdown
                    name={`machineDetails-${activeProduct}-${machine.type}-powerOfMachine`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.powerOfMachine || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "powerOfMachine",
                        e.target.value
                      );
                    }}
                    required
                    size="small"
                  >
                    <MenuItem value={2.5}>2.5 kW</MenuItem>
                    <MenuItem value={3.5}>3.5 kW</MenuItem>
                    <MenuItem value={4.5}>4.5 kW</MenuItem>
                    <MenuItem value={6}>6 kW</MenuItem>
                    <MenuItem value={7.5}>7.5 kW</MenuItem>
                  </TextField>
                ) : field === "lengthFoot" ? (
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      disabled={operation == "view"}
                      size="small"
                      select
                      name={`machineDetails-${activeProduct}-${machine.type}-lengthFoot`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.lengthFoot || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "lengthFoot",
                          e.target.value
                        );
                      }}
                      required
                    >
                      <MenuItem value={8}>8'</MenuItem>
                      <MenuItem value={10}>10'</MenuItem>
                      <MenuItem value={12}>12'</MenuItem>
                    </TextField>
                  </Grid>
                ) : field === "breadthFoot" ? (
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      disabled={operation == "view"}
                      size="small"
                      name={`machineDetails-${activeProduct}-${machine.type}-breadthFoot`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.breadthFoot || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "breadthFoot",
                          e.target.value
                        );
                      }}
                      InputProps={{
                        readOnly: true, // Prevent manual editing
                      }}
                    />
                  </Grid>
                ) : (
                  <TextField
                    fullWidth
                    disabled={operation == "view"}
                    select // Enables dropdown
                    size="small"
                    name={`machineDetails-${activeProduct}-${machine.type}-ageOfMachine`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.ageOfMachine || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "ageOfMachine",
                        e.target.value
                      );
                    }}
                    required
                  >
                    <MenuItem value="0-4">0 to 4 years</MenuItem>
                    <MenuItem value="4+">4 years and above</MenuItem>
                  </TextField>
                )}
              </FormControl>
            ) : machine.type === "Acrylic Laser Cutting Machine" ? (
              <FormControl
                fullWidth
                size="small"
                sx={{
                  marginBottom: "7px",
                }}
              >
                <label
                  style={{
                    fontWeight: "400",
                  }}
                >
                  {categoryLabels[field]}
                </label>
                {field === "subCategory" ? (
                  <Select
                    disabled={operation == "view"}
                    name={`machineDetails-${activeProduct}-${machine.type}-subCategories`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.subCategories || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "subCategories",
                        e.target.value
                      );
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span className="text-[var(--listdown-color)]">
                            Select Type of Machine
                          </span>
                        );
                      }
                      return selected;
                    }}
                    inputProps={{
                      "aria-label": `Select subCategories`,
                    }}
                    sx={{
                      marginTop: "0.5rem",
                    }}
                  >
                    {subCategories["Acrylic Laser Cutting Machine"]?.map(
                      (subCategoryOfMachine, i) => (
                        <MenuItem value={subCategoryOfMachine.value} key={i}>
                          {" "}
                          <Radio
                            checked={
                              formData?.products
                                ?.find((p) => p.productType === activeProduct)
                                ?.machinesNeededForFabrication?.find(
                                  (m) => m.type === machine.type
                                )?.details?.subCategories ===
                              subCategoryOfMachine.value
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleInputChangeMachineDetails(
                                  activeProduct,
                                  "machinesNeededForFabrication",
                                  machine.type,
                                  "subCategories",
                                  subCategoryOfMachine.value
                                );
                              }
                            }}
                            style={{
                              paddingRight: "8px",
                            }}
                          />
                          {subCategoryOfMachine.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                ) : field === "lengthFoot" ? (
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      disabled={operation == "view"}
                      fullWidth
                      size="small"
                      sx={{
                        marginTop: "0.5rem",
                      }}
                      select
                      name={`machineDetails-${activeProduct}-${machine.type}-lengthFoot`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.lengthFoot || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "lengthFoot",
                          e.target.value
                        );
                      }}
                      required
                    >
                      <MenuItem value={2}>2'</MenuItem>
                      <MenuItem value={3}>3'</MenuItem>
                      <MenuItem value={8}>8'</MenuItem>
                    </TextField>
                  </Grid>
                ) : field === "breadthFoot" ? (
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      disabled={operation == "view"}
                      size="small"
                      sx={{
                        marginTop: "0.5rem",
                      }}
                      name={`machineDetails-${activeProduct}-${machine.type}-breadthFoot`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.breadthFoot || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "breadthFoot",
                          e.target.value
                        );
                      }}
                      InputProps={{
                        readOnly: true, // Prevent manual editing
                      }}
                    />
                  </Grid>
                ) : field === "ageOfMachine" ? (
                  <TextField
                    fullWidth
                    size="small"
                    disabled={operation == "view"}
                    sx={{
                      marginTop: "0.5rem",
                    }}
                    select // Enables dropdown
                    // label="ageOfMachine"
                    name={`machineDetails-${activeProduct}-${machine.type}-ageOfMachine`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.ageOfMachine || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "ageOfMachine",
                        e.target.value
                      );
                    }}
                    required
                  >
                    <MenuItem value="0-4">0 to 4 years</MenuItem>
                    <MenuItem value="4+">4 years and above</MenuItem>
                  </TextField>
                ) : null}
              </FormControl>
            ) : machine.type === "Channel Letter Bending Machine" ? (
              <FormControl
                fullWidth
                size="small"
                sx={{
                  marginBottom: "7px",
                }}
              >
                <label
                  style={{
                    fontWeight: "400",
                  }}
                >
                  {categoryLabels[field]}
                </label>
                {field === "subCategory" ? (
                  <Select
                    disabled={operation == "view"}
                    name={`machineDetails-${activeProduct}-${machine.type}-${field}`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.[field] || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        field,
                        e.target.value
                      );
                    }}
                    displayEmpty
                    renderValue={(selected) => {
                      if (!selected) {
                        return (
                          <span className="text-[var(--listdown-color)]">
                            Select Type of Machine
                          </span>
                        );
                      }
                      return selected;
                    }}
                    inputProps={{
                      "aria-label": `Select ${field}`,
                    }}
                    sx={{
                      marginTop: "0.5rem",
                    }}
                  >
                    {subCategories["Channel Letter Bending Machine"]?.map(
                      (subCategoryOfMachine, i) => (
                        <MenuItem value={subCategoryOfMachine.value} key={i}>
                          <Radio
                            checked={
                              formData?.products
                                ?.find((p) => p.productType === activeProduct)
                                ?.machinesNeededForFabrication?.find(
                                  (m) => m.type === machine.type
                                )?.details?.[field] ===
                              subCategoryOfMachine.value
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                handleInputChangeMachineDetails(
                                  activeProduct,
                                  "machinesNeededForFabrication",
                                  machine.type,
                                  field,
                                  subCategoryOfMachine.value
                                );
                              }
                            }}
                            style={{
                              paddingRight: "8px",
                            }}
                          />
                          {subCategoryOfMachine.value}
                        </MenuItem>
                      )
                    )}
                  </Select>
                ) : field === "lengthFoot" ? (
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      disabled={operation == "view"}
                      size="small"
                      sx={{
                        marginTop: "0.5rem",
                      }}
                      select
                      name={`machineDetails-${activeProduct}-${machine.type}-lengthFoot`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.lengthFoot || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "lengthFoot",
                          e.target.value
                        );
                      }}
                      required
                    >
                      <MenuItem value={5}>5'</MenuItem>
                      <MenuItem value={4}>4'</MenuItem>
                      <MenuItem value={3}>3'</MenuItem>
                    </TextField>
                  </Grid>
                ) : field === "breadthFoot" ? (
                  <Grid item xs={12} sm={6} md={6}>
                    <TextField
                      fullWidth
                      disabled={operation == "view"}
                      size="small"
                      sx={{
                        marginTop: "0.5rem",
                      }}
                      name={`machineDetails-${activeProduct}-${machine.type}-breadthFoot`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.breadthFoot || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "breadthFoot",
                          e.target.value
                        );
                      }}
                      InputProps={{
                        readOnly: true, // Prevent manual editing
                      }}
                    />
                  </Grid>
                ) : field === "modelMachine" ? (
                  <>
                    <label>Select Machine Model</label>

                    <Select
                      disabled={operation === "view"}
                      name={`machineDetails-${activeProduct}-${machine.type}-modelMachine`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.modelMachine || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "modelMachine",
                          e.target.value
                        );
                      }}
                      displayEmpty
                      renderValue={(selected) => {
                        if (!selected) {
                          return (
                            <span className="text-[var(--listdown-color)]">
                              Select Machine Model
                            </span>
                          );
                        }
                        return selected;
                      }}
                      inputProps={{
                        "aria-label": "Select Machine Model",
                      }}
                      sx={{
                        marginTop: "0.5rem",
                      }}
                    >
                      {[
                        { label: "Flat Aluminum", value: "Flat Aluminum" },
                        {
                          label: "Trim Cap Aluminum",
                          value: "Trim Cap Aluminum",
                        },
                      ].map((option, i) => {
                        const selectedValue = formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.modelMachine;

                        return (
                          <MenuItem
                            key={i}
                            value={option.value}
                            onClick={() =>
                              handleInputChangeMachineDetails(
                                activeProduct,
                                "machinesNeededForFabrication",
                                machine.type,
                                "modelMachine",
                                option.value
                              )
                            }
                          >
                            <Radio
                              checked={selectedValue === option.value}
                              style={{ paddingRight: "8px" }}
                            />
                            {option.label}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </>
                ) : field === "wattage" ? (
                  <>
                    <label>Wattage Of Machine</label>
                    <TextField
                      fullWidth
                      disabled={operation == "view"}
                      size="small"
                      sx={{
                        marginTop: "0.5rem",
                      }}
                      select
                      name={`machineDetails-${activeProduct}-${machine.type}-wattage`}
                      value={
                        formData?.products
                          ?.find((p) => p.productType === activeProduct)
                          ?.machinesNeededForFabrication?.find(
                            (m) => m.type === machine.type
                          )?.details?.wattage || ""
                      }
                      onChange={(e) => {
                        handleInputChangeMachineDetails(
                          activeProduct,
                          "machinesNeededForFabrication",
                          machine.type,
                          "wattage",
                          e.target.value
                        );
                      }}
                      required
                    >
                      {[
                        {
                          label: "1500 W",
                          value: "1500",
                        },
                        {
                          label: "800 W",
                          value: "800",
                        },
                        {
                          label: "200 W",
                          value: "200",
                        },
                      ]?.map((option, i) => (
                        <MenuItem key={i} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </>
                ) : field === "ageOfMachine" ? (
                  <TextField
                    fullWidth
                    disabled={operation == "view"}
                    select
                    size="small"
                    sx={{
                      marginTop: "0.5rem",
                    }}
                    name={`machineDetails-${activeProduct}-${machine.type}-ageOfMachine`}
                    value={
                      formData?.products
                        ?.find((p) => p.productType === activeProduct)
                        ?.machinesNeededForFabrication?.find(
                          (m) => m.type === machine.type
                        )?.details?.ageOfMachine || ""
                    }
                    onChange={(e) => {
                      handleInputChangeMachineDetails(
                        activeProduct,
                        "machinesNeededForFabrication",
                        machine.type,
                        "ageOfMachine",
                        e.target.value
                      );
                    }}
                    required
                  >
                    <MenuItem value="0-4">0 to 4 years</MenuItem>
                    <MenuItem value="4+">4 years and above</MenuItem>
                  </TextField>
                ) : null}
              </FormControl>
            ) : (
              <></>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default FabricationMachinesDetails;
